// extracted by mini-css-extract-plugin
export var about = "AuthorCard-module--about--75a8c";
export var avatar = "AuthorCard-module--avatar--b34c1";
export var caption = "AuthorCard-module--caption--34c3b";
export var image = "AuthorCard-module--image--adcea";
export var largeAbout = "AuthorCard-module--largeAbout--22cd0";
export var link = "AuthorCard-module--link--898dc";
export var name = "AuthorCard-module--name--09872";
export var placeholder = "AuthorCard-module--placeholder--32de5";
export var root = "AuthorCard-module--root--ab611";